import { AntimalwareAntiExploitApplication } from '@nirvana/shared/dtos/types/policies/common';
import { AntimalwareAntiExploitUiApplication } from '../../../../utils/uiSettings/antimalware/antimalware.types';

export function convertDbApplicationToUiApplication(
  dbApplication: AntimalwareAntiExploitApplication
): AntimalwareAntiExploitUiApplication {
  return {
    applicationName: dbApplication.details.applicationName,
    processName: dbApplication.details.processName,
    status: dbApplication.details.status,
    exploitDetectionTechniques: dbApplication.exploitDetectionTechniques,
  };
}

export function convertUiApplicationToDbApplication(
  uiApplication: AntimalwareAntiExploitUiApplication
): AntimalwareAntiExploitApplication {
  return {
    details: {
      applicationName: uiApplication.applicationName,
      processName: uiApplication.processName,
      status: uiApplication.status,
    },
    exploitDetectionTechniques: uiApplication.exploitDetectionTechniques,
  };
}
